var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollBarRef",
      staticClass: "scroll-container pointer",
      class: [_vm.visible ? "padding-y-15" : ""],
    },
    [
      _vm.visible
        ? _c(
            "div",
            {
              staticClass: "yd-scroll-bar",
              style: { width: _vm.tableWidth + "px", height: "8px" },
            },
            [_c("div", { staticClass: "bar" })]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }